export const AgreementNotesValidation = (formData) => {
    const errors = {};

    if (!formData.contractDetails || !formData.contractDetails.trim()) {
        errors.contractDetails = 'This field is required';
    }

    
    return errors;
};
